// T2026: lokalni `.env` nosi `VITE_SENTRY_DSN`, ker ga potrebuje produkcijski
// build za staging. Razvojni strežnik (`npm run dev`) zato Sentry vklopi samo
// ob izrecni zahtevi `VITE_SENTRY_DEV_ENABLED=1` — sicer vsak lokalni šum
// porabi kvoto, ki si jo delimo s stagingom in produkcijo.
export interface SentryGateEnv {
  DEV: boolean
  VITE_SENTRY_DSN?: string
  VITE_SENTRY_DEV_ENABLED?: string
}

export function shouldInitSentry(env: SentryGateEnv): boolean {
  if (!env.VITE_SENTRY_DSN) return false
  if (!env.DEV) return true
  return env.VITE_SENTRY_DEV_ENABLED === '1'
}
